(function () {
  if (window.GSSizeGuide) return;

  var STORAGE_KEY = 'gs-care-guide';
  var CHECK_KEY = 'gs-material-check';

  function read(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function write(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (e) {}
  }

  function checkResult() {
    try {
      var saved = JSON.parse(read(CHECK_KEY) || 'null');
      return saved && saved.match ? saved.match : null;
    } catch (e) {
      return null;
    }
  }

  function urlParam() {
    try {
      return new URLSearchParams(window.location.search).get('material');
    } catch (e) {
      return null;
    }
  }

  function SizeGuide(root) {
    this.root = root;
    this.tabs = Array.prototype.slice.call(root.querySelectorAll('.gs-sg__tab'));
    if (!this.tabs.length) return;
    this.keys = this.tabs.map(function (tab) {
      return tab.getAttribute('data-gs-sg-tab');
    });
    this.bind();
    var design = window.Shopify && window.Shopify.designMode;
    var start = design ? null : urlParam() || read(STORAGE_KEY) || checkResult();
    this.show(this.keys.indexOf(start) > -1 ? start : root.getAttribute('data-default') || this.keys[0], false);
  }

  SizeGuide.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-gs-sg-tab]');
      if (!trigger || !self.root.contains(trigger)) return;
      self.show(trigger.getAttribute('data-gs-sg-tab'), true);
    });
  };

  SizeGuide.prototype.show = function (key, save) {
    if (this.keys.indexOf(key) === -1) return;
    this.tabs.forEach(function (tab) {
      tab.setAttribute('aria-pressed', tab.getAttribute('data-gs-sg-tab') === key ? 'true' : 'false');
    });
    this.root.querySelectorAll('[data-gs-sg-mat]').forEach(function (el) {
      el.hidden = el.getAttribute('data-gs-sg-mat') !== key;
    });
    if (save) write(STORAGE_KEY, key);
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-gs-size-guide]').forEach(function (root) {
      if (root.__gsSizeGuide) return;
      root.__gsSizeGuide = new SizeGuide(root);
    });
  }

  window.GSSizeGuide = { init: init };
  init();
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
